import { useMediaQuery as useMuiMediaQuery } from "@mui/material";
import mediaQuery from "css-mediaquery";
export const useMediaQuery = (query) => useMuiMediaQuery(query, {
    noSsr: false,
    ssrMatchMedia: (query) => {
        return {
            matches: mediaQuery.match(query, {
                width: "0px",
            }),
        };
    },
});
//# sourceMappingURL=mediaQuery.js.map